import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Hero from "../components/Hero";
import BrandsStrip from "../components/BrandsStrip";
import FeaturedProducts from "../components/FeaturedProducts";
import CategoryGrid from "../components/CategoryGrid";
import RightRail from "../components/RightRail";
import TrustStrip from "../components/TrustStrip";
import { homeTrust } from "../mock";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header variant="home" />
      <Navbar />
      <div className="max-w-[1400px] mx-auto px-3 lg:px-4 py-4">
        <div className="flex gap-4 items-start">
          <aside className="hidden lg:block w-[228px] shrink-0 sticky top-[86px]">
            <Sidebar />
          </aside>
          <main className="flex-1 min-w-0 space-y-6">
            <Hero />
            <BrandsStrip />
            <FeaturedProducts />
            <CategoryGrid />
          </main>
          <aside className="hidden xl:block w-[252px] shrink-0 sticky top-[86px]">
            <RightRail />
          </aside>
        </div>
      </div>
      <TrustStrip items={homeTrust} cols={4} />
    </div>
  );
};

export default Home;
